export default "__VITE_ASSET__DX9gf8gy__"